export default __webpack_public_path__ + "static/media/regreen_visual_05.c55b3601.jpg";